import { render, staticRenderFns } from "./CompTarifFriends.vue?vue&type=template&id=234d1473"
import script from "./CompTarifFriends.vue?vue&type=script&lang=js"
export * from "./CompTarifFriends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports